import { useEffect, useState } from 'react';

export const FIRST_INTERACTION_EVENTS = [
  'mousemove',
  'touchstart',
  'scroll',
  'keydown'
];

/** Unlocks once on first user gesture (pointer, touch, scroll, or key). */
export const useFirstInteraction = (callback: () => void) => {
  const [wasInteracted, setWasInteracted] = useState(false);

  useEffect(() => {
    if (wasInteracted) return;

    const handleInteraction = () => {
      setWasInteracted(true);
      callback();

      FIRST_INTERACTION_EVENTS.forEach(event => {
        window.removeEventListener(event, handleInteraction, {
          capture: event === 'scroll'
        });
      });
    };

    FIRST_INTERACTION_EVENTS.forEach(event => {
      window.addEventListener(event, handleInteraction, {
        passive: true,
        capture: event === 'scroll'
      });
    });

    return () => {
      FIRST_INTERACTION_EVENTS.forEach(event => {
        window.removeEventListener(event, handleInteraction, {
          capture: event === 'scroll'
        });
      });
    };
  }, [callback, wasInteracted]);

  return wasInteracted;
};
